<template>
  <div class="card">
    <div class="card-header"><h2 style="font-size: 22px;">Terms Of Service Acknowledgement</h2></div>
    <div class="card-body">
      <b-row class="mb-3">
        <b-col class="font-italic">
          Please read and acknowledge below.
        </b-col>
      </b-row>
      <TosContent/>
      <b-row class="mt-3">
        <b-col class="font-italic">
          Customer must acknowledge they have read and agree to the the terms.
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="12" md="6">
          <BaseTextInput v-model="signature"
                         :v="$v.signature"
                         slug="signature"
                         label="Signature"
                         setId="sig"
          />
        </b-col>
        <b-col cols="12" md="6">
          <BaseDateInput v-model="dateSigned"
                         :v="$v.dateSigned"
                         label="Today's Date"
                         slug="dateSigned"
                         :disabled="true"
                         setId="dtSig"
                         aria-disabled="true"
          />
        </b-col>
      </b-row>
    </div>
  </div>

</template>
<script>
import BaseTextInput from '@/components/templates/input/BaseTextInput.vue'
import BaseDateInput from '@/components/templates/input/BaseDateInput.vue'
import { required } from 'vuelidate/lib/validators'
import axios from "axios"
import axiosRetry from 'axios-retry'
import TosContent from "@/components/checkout-wizard/TosContent.vue";
import {toastService} from "@/mixins/toastService";
import LocalStorageService from "@/common/LocalStorageService";

axiosRetry(axios, { retries: 3,
  retryDelay: axiosRetry.exponentialDelay  })

const localStorageService = LocalStorageService.getService();

export default {
  data: () => {
    return {
      signature: null,
      dateSigned: new Date().toISOString().slice(0,10),
    }
  },
  components: {
    TosContent,
    BaseTextInput,
    BaseDateInput
  },
  validations() {
    return {
      signature:{ required },
      dateSigned: { required },
      form: [ 'signature','dateSigned' ]
    }
  },
  methods: {
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid
      this.$emit('on-validate', this.$data, isValid, 'tos')
      return isValid
    },
    submit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      let payload = {
        id: localStorageService.getOrderNumber(),
        name: this.signature
      }
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/order/sign`, payload)
          .then(response=> {
            this.$emit('on-submit')
            toastService.showRootToast("Success", "Signature Accepted" , "success", this.$root)
          })
          .catch(err => {
            toastService.showRootToast("Error", "An error has occurred" , "danger", this.$root)
          })
    },
  }
}
</script>
